module.exports = __webpack_public_path__ + "static/media/ic_arrow_more_white.1a525e6b.svg";